import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  itemContainer: {
    background: theme.palette.background.paper,
    padding: '0 10px',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '5px',
  },
  itemsList: {
    paddingTop: '8px',
    gap: '10px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    height: '90vh',
    color: theme.palette.text.primary
  },
  form: {
    margin: '20px auto',
    width: '50%',
    display: 'flex',
    padding: '20px',
    background: theme.palette.background.paper,
    boxSizing: 'border-box',
    borderRadius: '5px',
    flexDirection: 'column',
    maxHeight: '100%',
    overflow: 'hidden',
  },
  formTeams: {
    height: '100%',
    margin: '0px auto',
    width: '50%',
    display: 'flex',
    padding: '20px',
    background: theme.palette.background.paper,
    boxSizing: 'border-box',
    borderRadius: '5px',
    flexDirection: 'column',
    maxHeight: '100%',
    overflow: 'hidden',
  },
  formHeader: {
    display: 'flex',
    padding: '20px 10px',
    alignItems: 'center',
    fontWeight: 800,
    justifyContent: 'space-between',
    fontSize: 'large',
    color: theme.palette.text.primary,
  },
  itemHeader: {
    display: 'flex',
    justifyContent: 'start',
    gap: '10px',
  },
  itemHeaderStatus: {
    color: 'red',
  },
  title: { whiteSpace: 'pre-wrap' },
}));

export default useStyles;
